import React from 'react';
import './FaQ.scss';
import { useNavigate, useParams } from "react-router-dom";

const FaQ = () => {
    const navigate = useNavigate();
    return <div className='faq fade-in-block'>

        <h3>What is the difference between Counselling and Psychotherapy?</h3>
        <p>
        Broadly speaking, counselling provides an environment for you to explore your thoughts and feelings in a safe and supportive way. 
        Psychotherapy provides this too, but it also goes a step further and aims to identify and examine the root causes of these feelings. When you understand why you feel like you do, you will be able to make fresh choices moving forwards.
        </p>
        <h3>How many sessions will I need?</h3>
        <p>
            At the start of therapy, it can be really difficult to know how many 
            sessions will be beneficial to you. I therefore work with most of my clients 
            in an ‘open ended way’, which means that we do not fix the number of sessions 
            from the start. This allows for a deeper exploration of the material that you 
            bring and gives us the time and space to really think about your needs. 
            As our work develops, we can then discuss how many sessions may be useful for you. 
        </p>
        <h3>What is the average time that people stay in therapy for?</h3>
        <p>
            This really depends on the individual. Some clients stay in therapy for a number of months, others will attend for several years.
        </p>
        <h3>Can I attend more than once a week?</h3>
        <p>
        Attending sessions on a more frequent basis (two or more times per week) adds greater depth to the therapy and can result in an enhanced level of understanding and wellbeing.
        </p>

        <h3>Can I attend sessions fortnightly or monthly?</h3>
        <p>When you start therapy with me, I want to make sure that you get the best out of your sessions and this does mean making a commitment to attend each week. I find that too much time passes between sessions if we meet fortnightly and this makes the work less effective. I therefore only work with clients on a weekly basis. </p>

        <h3>How much notice do I have to give to end sessions?</h3>
        <p>
        If you decide that you no longer want to attend psychotherapy, you can finish our sessions at any time. However if you have attended a number of psychotherapy sessions, I would suggest that we work towards a mutually agreed ending date over a number of weeks.
        </p>
        
        <h3>Do I have to pay for missed sessions? </h3>
        <p>
            When we agree to work together in an open-ended way, your timeslot is reserved for you each week. I therefore ask that all missed sessions are paid for. This includes sessions missed due to holidays, appointments or illness.
        </p>
        
        <h3>Are you qualified? </h3>
        <p>
            Yes. I trained for 5 years to become a Psychotherapist and am fully qualified with a Masters Degree in Psychotherapy. To find out more about my qualifications, please click  <span className='link' onClick={() => navigate('/about') }>here</span> .
        </p>
        
        <h3>Do I have an accessible office?</h3>
        <p>
            My office is situated on the ground floor of Worting House and there is accessible parking by the back entrance. There is one small step to navigate on the way to my consulting room but we do have an accessibility ramp which means that there is wheelchair access into my room. 
        </p>
        <h3>Do I cater for counselling students?</h3>
        <p>
            Yes, I am able to provide counselling to students who are studying on a psychodynamic or integrative course. Unfortunately I am not able to provide a reduction on my fees for students.
         </p>
        <h3>Do I offer supervision?</h3>
        <p>
        At this time I have do not have capacity to offer supervision.
        </p>
        <h3>Can I offer couples counselling?</h3>
        <p>
        No. I specialise in working with individual adults.
        </p>
        <h3>Do I offer children or young person counselling?</h3>
        <p>
        No. I am unable to work with anyone who is under 18 years old.
        </p>

        <h3>Where can I find your privacy statement?</h3>
        <p>For details of how I comply with GDPR, click this <span className='link' onClick={() => navigate('/privacy')}>link</span>.</p >
    </div>;
}

export { FaQ };
